import {
  types,
} from './actions';

const initialState = {
  showUserEntryModal: false,
  user: {},
  showTerminatedUsers: false,
};

const userList = (state = initialState, action) => {
  switch (action.type) {
    case types.OPEN_ENTRY_MODAL: {
      const { user } = action;
      return {
        ...state,
        showUserEntryModal: true,
        user,
      };
    }
    case types.CLOSE_ENTRY_MODAL: {
      return {
        ...state,
        showUserEntryModal: false,

      };
    }
    case types.SET_SHOW_TERMINATED_USERS: {
      const { showTerminatedUsers } = action;
      return {
        ...state,
        showTerminatedUsers,
      };
    }
    default:
      return state;
  }
};

export default userList;
